export default function navState(state = '', action) {
    switch (action.type) {
        case 'CHANGE_NAV':
            return action.payload
        default:
            return state  
    }
}